export class CreateCredentialsProfileInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "awsCredentialProfile",
            "baseName": "awsCredentialProfile",
            "type": "CreateCredentialsProfileInputAwsCredentialProfile",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateCredentialsProfileInput.attributeTypeMap;
    }
    constructor() {
    }
}
